import React, { useEffect, useState } from "react";
import { Dialog } from "primereact/dialog";
import Buttonc from "../../../stories/common/button";
import styles from "./index.module.scss";
import { Checkbox } from "primereact/checkbox";
import { useAddNotes } from "../../../hooks/react-query/investor-dashboard/useAddNotes";
import { useToast } from "../../../stories/common/toast/toast";
import { useEditNotes } from "../../../hooks/react-query/investor-dashboard/useEditNotes";
import { Tooltip } from "primereact/tooltip";

interface AddNotesDialogProps {
  visible: boolean;
  setVisible: React.Dispatch<React.SetStateAction<boolean>>;
  heading: string;
  placeholder: string;
  propertyId: string;
  accountId: string;
  isEdit: boolean;
  item?: any;
}

const AddNotesDialog: React.FC<AddNotesDialogProps> = ({
  visible,
  setVisible,
  heading,
  placeholder,
  accountId,
  propertyId,
  isEdit,
  item
}) => {
  const [note, setNote] = useState(isEdit ? item?.notes : "");
  const [isPrivate, setIsPrivate] = useState(isEdit ? !item?.isPrivate : false);
  const { showSuccess, showInfo }: any = useToast();
  useEffect(() => {
    setNote(isEdit ? item?.notes : "");
    setIsPrivate(isEdit ? !item?.isPrivate : false);
  }, [isEdit, item]);
  const EditNotesMutation = useEditNotes(
    (data) => {
      showSuccess("success", "Notes updated Successfully.");
      setVisible(false);
      setNote("");
      setIsPrivate(false);
    },
    (error) => {
      showSuccess("success", "Failed to update notes.");
      console.log("error", error);
    }
  );
  const addNotesMutation = useAddNotes(
    (data) => {
      showSuccess("success", "Notes added Successfully.");
      setVisible(false);
      setNote("");
      setVisible(false);
    },
    (error) => {
      showSuccess("success", "Failed to add notes.");
      console.log("error", error);
    }
  );

  return (
    <Dialog
      blockScroll={true}
      visible={visible}
      closable={true}
      closeOnEscape={true}
      header={<span className={styles.header}>{heading}</span>}
      dismissableMask={true}
      onHide={() => setVisible(false)}
      className={styles.dialog}
      maskClassName={styles.dialogMask}
      draggable={false}
      resizable={false}
    >
      <div className={styles.checkBoxWrap}>
        <Checkbox
          type="checkbox"
          checked={isPrivate}
          className={styles.checkBox}
          onChange={(e: any) => setIsPrivate(e.target.checked)}
        />
        <label className={styles.checkboxLabel}>
          Make it Public
          <img src="/images/info-icon.svg" alt="" className={"infoIcon"} />
          <Tooltip
            target=".infoIcon"
            className={styles.tooltip}
            position="bottom"
            content={"Public notes will be visible to other agents"}
          />
        </label>
      </div>
      <textarea
        name="add-notes"
        id="notes"
        className={styles.textarea}
        placeholder={placeholder}
        value={note}
        maxLength={350}
        onChange={(e) => setNote(e.target.value)}
        rows={6}
      />
      <div className={styles.btnWrap}>
        <Buttonc
          btnType="border"
          type="submit"
          tabIndex={7}
          btnWrapClassName={styles.btnWrapClass}
          className={styles.cancelBtn}
          label={"Cancel"}
          disabled={addNotesMutation.isPending || EditNotesMutation.isPending}
          onClick={() => {
            setVisible(false);
          }}
        />
        <Buttonc
          type="submit"
          btnWrapClassName={styles.btnWrapClass}
          tabIndex={7}
          label={"Save"}
          loading={addNotesMutation.isPending || EditNotesMutation.isPending}
          className={styles.subBtn}
          onClick={() => {
            if (note.trim() !== "") {
              if (isEdit) {
                EditNotesMutation.mutate({
                  accountId: accountId,
                  pubPropertyId: propertyId,
                  notes: note,
                  isPrivate: !isPrivate,
                  id: item?.id
                });
              } else {
                addNotesMutation.mutate({
                  accountId: accountId,
                  pubPropertyId: propertyId,
                  notes: note.trim(),
                  isPrivate: !isPrivate
                });
              }
            } else {
              showInfo("info", "Please enter some notes.");
            }
          }}
        />
      </div>
    </Dialog>
  );
};

export default AddNotesDialog;
